<template>
  <div>
    <div class="d-flex">
      <h4 class="font-weight-medium font-16" v-text="DESCRICAO_PRODUTO" />
      <DetalhamentoCategoriaDialog :detalhamento_categoria="detalhamento_categoria">
        <template #prepend-card-text>
          <h4 class="mt-2 font-15 font-weight-medium">{{DESCRICAO_PRODUTO}}</h4>
        </template>
      </DetalhamentoCategoriaDialog>
    </div>

    <table style="width: 100%;border-collapse: collapse;">
      <template v-for="(linha, index) in linhas">
        <linha
          :linha="linha"
          :dados="detalhamento_categoria"
          :key="index"
          :maximoDeColunas="maximoDeColunas"
          class_column="pb-1"
        >
          <template #coluna.ressuprimento_em_dias="{coluna}">
            <Ressuprimento
              :coluna="coluna"
              :categoria="categoria"
              :detalhamento_categoria="detalhamento_categoria"
            />
          </template>

          <template #coluna.lote_minimo="{coluna}">
            <LoteMinimo
              :coluna="coluna"
              :categoria="categoria"
              :detalhamento_categoria="detalhamento_categoria"
              @novo-lote-minimo="detalhamento_categoria.lote_minimo = $event"
            />
          </template>

          <template #coluna.valor.nome_produto_heranca="{valor}">
            <v-tooltip bottom open-delay="700">
              <template #activator="{ on, attrs }">
                <p v-bind="attrs" v-on="on" class="ma-0 text-truncate cursor-help" style="width: 180px">
                  {{valor}}
                </p>
              </template>
              <span>{{valor}}</span>
            </v-tooltip>
          </template>

          <template #coluna.valor.estoque="{valor}">
            <div class="d-flex align-center">
              {{ Helpers.formatarValor(valor) }}

              <EstoquePorLojaDialog :parametros="{grupo: grupo_compra, idcategoria: categoria.idcategoria}">
                <template #topo-tabela>
                  <p class="font-15">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_PRODUTO}}
                  </p>
                </template>
              </EstoquePorLojaDialog>
            </div>
          </template>

          <template #coluna.cobertura_manual>
            <CoberturaManual :detalhamento_categoria="detalhamento_categoria" />
          </template>

          <template #coluna.previsao_gatilho_categoria>
            <PrevisaoGatilho :detalhamento_categoria="detalhamento_categoria" />
          </template>

          <template #coluna.compra_transito="{coluna}">
            <p class="ma-0 font-weight-medium">
              {{coluna.texto}}
              <v-icon small color="#D60E2B">mdi-truck</v-icon>
            </p>

            <div class="d-flex align-center">
              <p class="ma-0 mt-n1" style="color: #D60E2B">{{Helpers.formatarValor(detalhamento_categoria[coluna.valor])}}</p>

              <PedidosPendente
                v-if="detalhamento_categoria[coluna.valor] > 0"
                class="mt-n1"
                :filtros="{grupo: grupo_compra, idcategoria: categoria.idcategoria}"
              >
                <template #topo-tabela>
                  <p class="font-15">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_PRODUTO}}
                  </p>
                </template>
              </PedidosPendente>
            </div>
          </template>

          <template #coluna.valor.status_categoria="{valor}">
            <v-tooltip bottom open-delay="700">
              <template #activator="{ on, attrs }">
                <p v-bind="attrs" v-on="on" class="ma-0 text-truncate cursor-help" style="width: 90px">
                  {{`${valor}`.toLowerCase()}}
                </p>
              </template>
              <span>{{`${valor}`.toLowerCase()}}</span>
            </v-tooltip>
          </template>

          <template #coluna.valor.nivel_estoque="{valor}">
            <nivel-estoque-progress-circular
              :tamanho="58"
              :largura="8"
              :valor="valor"
              :status-produto="detalhamento_categoria.status_categoria"
            />
          </template>

          <template #ultima-compra>
            <div class="d-flex">
              <span>Última Compra</span>

              <UltimasCompras :filtros="{grupo: grupo_compra, idcategoria: categoria.idcategoria}">
                <template #topo-tabela>
                  <p class="font-15">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_PRODUTO}}
                  </p>
                </template>
              </UltimasCompras>
            </div>
          </template>

          <template #media-venda-ultimos-meses>
            <div class="d-flex">
              <span>Média de venda nos últimos meses</span>

              <VendasUltimosMeses :filtros="{grupo: grupo_compra, idcategoria: categoria.idcategoria}">
                <template #topo-corpo>
                  <p class="font-15 pt-3 pl-5">
                    <span class="font-weight-medium pr-1">Categoria: </span>
                    {{DESCRICAO_PRODUTO}}
                  </p>
                </template>
              </VendasUltimosMeses>
            </div>
          </template>

          <template #coluna.valor.ordem_compra>
            {{ ultima_compra.ordem_compra || '-' }}
          </template>

          <template #coluna.valor.total_compra>
            {{ Helpers.formatarValor(ultima_compra.total_compra || 0) }}
          </template>

          <template #coluna.valor.qtde>
            {{ Helpers.formatarValor(ultima_compra.qtde || 0) }}
          </template>

          <template #coluna.valor.data_solicitacao>
            {{ ultima_compra.data_solicitacao || 0 }}
          </template>

          <template #coluna.valor.data_previsao>
            {{ ultima_compra.data_previsao || 0 }}
          </template>

          <template #coluna.valor.data_entrega>
            {{ ultima_compra.data_entrega || 0 }}
          </template>

          <template #coluna.valor.media_trimestre>
            {{ Helpers.formatarValor(media_vendas.media_trimestre || 0) }}
          </template>

          <template #coluna.valor.media_semestre>
            {{ Helpers.formatarValor(media_vendas.media_semestre || 0) }}
          </template>

          <template #coluna.valor.media_ano>
            {{ Helpers.formatarValor(media_vendas.media_ano || 0) }}
          </template>
        </linha>
      </template>
    </table>
  </div>
</template>

<script>
import Linha from "../../../produto/detalhes/LinhaTabelaDetalhesProdutos.vue";
import NivelEstoqueProgressCircular from "../../../produto/detalhes/NivelEstoqueProgressCircular.vue";
import {buscarDetalhamentoCategoria} from "@/api/compraPorDepartamentos/Categoria";
import {parametros_rota} from "../helpers/ParametrosRota";
import {logout} from "@/helpers";
import LoteMinimo from "./LoteMinimo.vue";
import PedidosPendente from "./PedidosPendente";
import UltimasCompras from "./UltimasCompras";
import VendasUltimosMeses from "./VendasUltimosMeses";
import EstoquePorLojaDialog from "../../../dashboard/departamentos/EstoquePorLojaDialog";
import Ressuprimento from "./Ressuprimento.vue"
import CoberturaManual from "./CoberturaManual";
import DetalhamentoCategoriaDialog from "./DetalhamentoCategoriaDialog";
import PrevisaoGatilho from "./PrevisaoGatilho";

export default {
  name: "TabelaDetalhesCategoria",
  mixins: [parametros_rota],
  components: {
    PrevisaoGatilho,
    DetalhamentoCategoriaDialog,
    CoberturaManual,
    EstoquePorLojaDialog,
    VendasUltimosMeses,
    UltimasCompras,
    PedidosPendente,
    NivelEstoqueProgressCircular,
    Linha,
    LoteMinimo,
    Ressuprimento
  },
  props: {
    categoria: {
      type: Object,
      required: true
    },
    ocultarTituloEstoquesCoberturas: {
      type: Boolean,
      default: false
    },
    count_atualizar_detalhes_categoria: Number,
  },
  data: () => ({
    maximoDeColunas: 6,
    detalhamento_categoria: {
      unidade_compra: '-',
      ressuprimento_em_dias: '-'
    },
    linhas: [
      {
        colunas: [
          {texto: 'Prioridade', valor: 'peso_compras'},
          {texto: 'Preço de Compra', valor: 'preco_compra', formatarDinheiro: true},
          {texto: 'Ressuprimento', valor: 'ressuprimento_em_dias', formatar: true, append: 'dias'},
          {texto: 'Lote Mínimo', valor: 'lote_minimo', formatar: true},
          {texto: 'Embalagem', valor: 'unidade_compra'},
          {texto: 'Previsão gatilho', valor: 'previsao_gatilho_categoria'},
        ]
      },
      {
        divider: true,
        titulo: 'Estoques e coberturas',
      },
      {
        colunas: [
          {texto: 'Nível Estoque', valor: 'nivel_estoque', rowspan: 2},
          {texto: 'Saldo de Estoque', valor: 'estoque', formatar: true},
          {texto: 'Estoque Segurança', valor: 'estoque_seguranca', formatar: true},
          {texto: 'Ponto de Pedido', valor: 'ponto_pedido', formatar: true},
          {texto: 'Estoque Máximo', valor: 'estoque_maximo', formatar: true},
          {texto: 'Cobertura Manual', valor: 'cobertura_manual', formatar: true},
        ]
      },
      {
        colunas: [
          {texto: 'Cobertura Instântanea', valor: 'cobertura_instantanea_diaria', formatar: true, append: 'dias'},
          {texto: 'Cobertura Eseg', valor: 'cobertura_esseg_diaria', formatar: true, append: 'dias'},
          {texto: 'Cobertura PP', valor: 'cobertura_pp_diaria', formatar: true, append: 'dias'},
          {texto: 'Cobertura Emax', valor: 'cobertura_emax_diaria', formatar: true, append: 'dias'},
          {texto: 'Giro de Estoque', valor: 'giro_diario', formatar: true},
        ]
      },
      {
        colunas: [
          {texto: 'Status Categoria', valor: 'status_categoria'},
          {texto: 'Fator de Conversão', valor: 'fator_conversao', formatar: true},
          {texto: 'Bloqueado', valor: 'estoque_bloqueado', formatar: true},
          {texto: 'Em Trânsito', valor: 'compra_transito', formatar: true},
          {texto: 'Avaria', valor: 'estoque_avaria', formatar: true},
          {texto: 'Reservado', valor: 'estoque_reservado', colspan: 2, formatar: true},
        ]
      },
      {
        divider: true,
        titulo: 'Última Compra',
        nome: 'ultima-compra'
      },
      {
        colunas: [
          {texto: 'Pedido', valor: 'ordem_compra'},
          {texto: 'Total item', valor: 'total_compra'},
          {texto: 'Quantidade', valor: 'qtde'},
          {texto: 'Solicitação', valor: 'data_solicitacao'},
          {texto: 'Previsão', valor: 'data_previsao'},
          {texto: 'Entrada', valor: 'data_entrega'}
        ]
      },
      {
        divider: true,
        titulo: 'Média de venda nos últimos meses',
        nome: 'media-venda-ultimos-meses'
      },
      {
        colunas: [
          {texto: '3 meses', valor: 'media_trimestre', formatar: true},
          {texto: '6 meses', valor: 'media_semestre', formatar: true},
          {texto: '12 meses', valor: 'media_ano', formatar: true},
          {texto: 'Projeção de vendas', valor: 'consumo_medio_mensal', formatar: true},
          //{texto: 'Influência de Projeção', valor: 'percentual_projecao', formatar: true, colspan: 2, append: '%'}
        ]
      }
    ]
  }),
  computed: {
    DESCRICAO_PRODUTO() {
      const {idcategoria, descricao_categoria} = this.categoria;

      const decricao_formatada = `${descricao_categoria[0] || ''}`.toUpperCase();

      return `${idcategoria} - ${decricao_formatada.concat(descricao_categoria.substring(1).toLowerCase())}`
    },
    ultima_compra() {
      if (!this.detalhamento_categoria.ultima_compra) return {};
      return this.detalhamento_categoria.ultima_compra;
    },
    media_vendas() {
      if (!this.detalhamento_categoria.media_vendas) return {};
      return this.detalhamento_categoria.media_vendas;
    }
  },
  watch: {
    categoria() {
      this.getDetalhesCategoria();
    },
    count_atualizar_detalhes_categoria() {
      this.getDetalhesCategoria();
    }
  },
  mounted() {
    this.getDetalhesCategoria();
  },
  methods: {
    getDetalhesCategoria() {
      const parametros = {
        iddepartamento: this.categoria.iddepartamento,
        idsecao: this.categoria.idsecao,
        idcategoria: this.categoria.idcategoria,
        grupo: this.grupo_compra,
        filial: this.filial_compra
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarDetalhamentoCategoria(parametros).then(this.atualizarDados).catch(logout)
      );
    },
    atualizarDados(detalhamento) {
      this.detalhamento_categoria = detalhamento;
    }
  }
}
</script>

<style scoped>
</style>
